(function (angular) {
    "use strict";

    var commonFaultService = angular.module('service.CommonFault', []);

    commonFaultService.factory('commonFaultService', ['$http', 'halClient', 'appSettings', 'localStorageService', 'storageKeys', function ($http, halClient, appSettings, localStorageService, storageKeys) {

        var listByMachineId = appSettings.apiBaseUri + "/commonFault/query-by-machineId";

        return {
            listByMachineId: function (machineId) {
                return halClient.$get(listByMachineId + "?machineId=" + machineId);
            }
        }
    }]);
})(angular);